/**
 * Opens the share sheet of the device for a link. The browser rejects the promise with an AbortError when the user
 * closes the sheet without sharing: that is a normal choice of the user, not an error, so it is swallowed. Every
 * other error (share not allowed, invalid data) is passed on.
 */
export async function shareUrl (url) {
  try {
    await navigator.share({ url })
  } catch (error) {
    if (error?.name !== 'AbortError') {
      throw error
    }
  }
}
